import React from "react";
import { View, TouchableOpacity, Text, Image, StyleSheet, Vibration } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { fontFamily } from "../helpers/fontFamily";
import placeholder from "../../assets/placeholder.jpg";
import { useSelector } from "react-redux";
import DisplayQuantityInBox from './displayQunatityInBox';
import {getItemCounts} from '../components/ScanpackScanning/utils/itemQuantities';

const OrderItemImage = ({ item, shuffleTheItem, testID, listType, isNotFullFilled = false, boxQty, boxName, onRemoveFromBox }) => {
  const isHaptic = useSelector((state) => state.menu.isHaptics);
  const counts = getItemCounts(item);
  const totalQty = counts.total;
  const notFullFilledQty =  item.scanned_qty + item.skipped_qty
  return (
    <TouchableOpacity
      key={item?.id}
      testID={testID}
      onPress={() => {
        isHaptic && Vibration.vibrate(30)
        shuffleTheItem(item.sku);
      }}
    >
      <View style={styles.container}>
        <LinearGradient
          locations={[0, 0.04, 0.08]}
          start={{ x: 0.9, y: 1 }}
          colors={["#3d4851", "#9EA4A8", "#ffffff"]}
          style={styles.gradientContainer}
        >
          <Text style={styles.gradientText} dataSet={{ componentName: 'productUnscannedKitCount'}}>
            {/* {item.qty_remaining}/{item?.total_qty === undefined || item.total_qty < item.qty_remaining + item.scanned_qty ? 
              item.qty_remaining + item.scanned_qty : item.total_qty} */}
            {(listType === 'unscanned') ? `${counts.remaining}/${totalQty}` : `${counts.scanned}/${isNotFullFilled ? notFullFilledQty :totalQty} `  }
          </Text>

          {item?.images[0]?.image ? (
            <Image
              defaultSource={placeholder}
              source={{ uri: item?.images[0]?.image }}
              style={styles.imageContainer}
            />
          ) : (
            <Image source={placeholder} style={styles.imageContainer} />
          )}
          {onRemoveFromBox && (
            <TouchableOpacity
              testID="removeBox"
              dataSet={{ componentName: 'removeBoxItem' }}
              onPress={onRemoveFromBox}
              style={styles.removeButton}>
              <i className="icon-cancel" style={{ fontSize: 21 }}></i>
            </TouchableOpacity>
          )}
          {boxQty !== undefined && boxName && (
            <DisplayQuantityInBox qty={boxQty} boxName={boxName} />
          )}
        </LinearGradient>
      </View>
    </TouchableOpacity>
  );
};
const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%",
  },
  gradientContainer: {
    height: 118,
    width: 100,
    backgroundColor: "#000000",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.58,
    shadowRadius: 29,
    elevation: 3,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    marginTop: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  gradientText: {
    width: "100%",
    position: "absolute",
    textAlign: "center",
    fontSize: 18,
    fontFamily: fontFamily.font600,
    backgroundColor: "#fff",
    opacity: 0.7,
    bottom: 0,
    right: 0,
    left: 0,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    marginLeft: "auto",
    marginRight: "auto",
    zIndex: 999,
  },
  imageContainer: {
    height: "100%",
    width: "100%",
    resizeMode: "cover",
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
  },
  removeButton: {
    zIndex: 2,
    color: 'red',
    marginLeft: 68,
    marginTop: -80,
    position: 'absolute',
  },
});
export default OrderItemImage;
